'use client'

import { ProductDetailV2Provider } from './product-detail'
import { SizeGuideProvider } from './side-guide-context'

// HOC: Bọc component với ProductDetailV2Provider
export const withProductDetailProvider = <P extends object>(Component: React.ComponentType<P>) => {
  const WithProvider = (
    props: P & {
      product: Product
      contentQuantity?: ITierPrices[]
      defaultColorUid?: string
      defaultSizeUid?: string
    }
  ) => {
    const { product, contentQuantity = [], defaultColorUid, defaultSizeUid, ...restProps } = props
    return (
      <ProductDetailV2Provider
        product={product}
        contentQuantity={contentQuantity}
        colorParam={defaultColorUid}
        sizeParam={defaultSizeUid}
      >
        {' '}
        <SizeGuideProvider>
          <Component {...(restProps as P)} product={product} />
        </SizeGuideProvider>{' '}
      </ProductDetailV2Provider>
    )
  }

  WithProvider.displayName = `withProductDetailProvider(${Component.displayName || Component.name || 'Component'})`
  return WithProvider
}
